export const colors = [
  '#5c6bc0',
  '#66bb6a',
  '#29b6f6',
  '#ffee58',
  '#ef5350',
  '#868e96'
];
